<template>
  <div class="iv-list-guide  iv-main-width iv-bg-w">
    <div class="iv-list-right no-menu">
      <div class="iv-broadcast">
        <p class="iv-list-right-title"><span>{{ broadcastList.title }}</span></p>
        <div class="iv-broadcast iv-broadcast2" @click="todetail(item)" v-for="item in menuList" :key="item.id">
          <img class="bg" :src="getImgPath(broadcastList.bgUrl)" @error="nofind"/>
          <div class="iv-broadcast-left" v-if="item.publishTime">
            <p>{{ item.title }}</p>
            <p>{{ item.publishTime.replaceAll('/', '.') }}</p>
          </div>
        </div>
      </div>
      <Page :total="total" :current="currentPage" :pageSize="pageSize" show-sizer show-elevator show-total
            :page-size-opts=pageSizeOpts
            class="iv-list-page" @on-change="changePage" @on-page-size-change="changePageSize"></Page>

    </div>
  </div>
</template>

<script>
import {newsPrefixPath} from '@/config'
import {timeFormat} from '@/utils'

export default {
  data() {
    return {
      broadcastList: {
        title: 'BEZ微讯',
        month: new Date().getFullYear() + '.' + (new Date().getMonth() + 1),
        day: new Date().getDate(),
        content: '',
        bgUrl: '~@/assets/images/news/broadcast.png'
      },
      contentList: [],
      menuList: [],
      total: 0,
      current: 1,
      currentPage: 1,
      categoryId: this.$route.query.categoryId || 'system_index',
      pageSize: 15,
      value: '',
      model1: true,
      pageSizeOpts: [5, 10, 15, 20]
    }
  },
  props: ['navData'],
  created() {
    this.getmanagerThought()
  },
  methods: {
    getmanagerThought() {
      let params = {
        columnId: this.categoryId,
        current: this.current,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        isDept: this.model1,
        title: this.value,
      }
      this.$ajax({
        url: 'api-qixuan/cms/front/getBlogListNews',//getBlogListNews
        method: 'get',
        data: params
      }).then(({data}) => {
        this.menuList = data.rows
        this.total = data.total || 0
        // this.contentList = data.rows
        // if (this.contentList.length > 0) {
        //   let publishDate = new Date(this.contentList[0].publishDate)
        //   this.broadcastList.bgUrl = this.contentList[0].guideBgImg
        //
        //   // this.getImgPath(this.contentList[0].guideBgImg)
        //   // this.broadcastList.month = publishDate.getFullYear() + '.' + (publishDate.getMonth() + 1)
        //   // this.broadcastList.day = publishDate.getDate()
        //   this.broadcastList.content = unescape(this.contentList[0].content)
        // }
      })
    },
    changePage(page) {
      this.current = page
      this.currentPage = page
      this.getmanagerThought()
    },
    changePageSize(page) {
      this.pageSize = page
      this.getmanagerThought()
    },
    getImgPath(id) {
      return id ? `${newsPrefixPath}file/downloadFile?fileId=${id}` : '~@/assets/images/news/broadcast.png'
    },
    getTime(d) {
      return timeFormat(d)
    },
    todetail(item) {
      if (item.id) {
        const {href} = this.$router.resolve({
          name: 'newsDetail',
          query: {
            infoId: item.id,
            categoryName: item.columnName
          }
        })
        window.open(href, '_blank')
      }
    },
    nofind() {
      var img = event.srcElement
      img.src = require('@/assets/images/news/broadcast.png')
      img.onerror = null
    },
    goToList(code, name) {
      console.log('121212==', this.navData['xwzbj'])
      const {href} = this.$router.resolve({
        name: 'xwzbj',
        query: {
          categoryCode: 'xwzbj',
          categoryName: 'BEZ微讯',
          categoryId: this.navData['xwzbj'].categoryId,
          categoryType: this.navData['xwzbj'].categoryType
        }
      })
      window.open(href, '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
.iv-broadcast2 {
  height: 316px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.iv-broadcast {
  // height: 364px;
  margin-top: 25px;
  // background-image: url('~@/assets/images/news/broadcast.png');
  // background-size: cover;
  // background-position: center center;
  position: relative;
  z-index: 0;
  overflow: hidden;


  .bg {
    position: absolute;
    left: 0;
    z-index: -1;
    right: 0;
    height: 100%;
    width: 100%;
  }

  .iv-broadcast-left {
    position: absolute;
    left: 46px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: "Microsoft YaHei";
    p:nth-of-type(1) {
      font-size: 42px;
      line-height: 1.2;
      font-weight: bold;
      color: #111A34;
    }

    p:nth-of-type(2) {
      font-size: 28px;
      color: #111A34;
      font-weight: bold;
    }

    p:nth-of-type(3) {
      margin: 16px 0 0 61px;
      font-size: 24px;
      font-weight: 500;
      color: #000000;
      text-align: center;
      width: 120px;
    }
  }

  .iv-broadcast-right {
    font-family: "Microsoft YaHei";
    float: right;
    width: calc(100% - 220px);
    padding: 0 50px;
    font-size: 14px;

    .iv-broadcast-each {
      margin-bottom: 16px;
      cursor: pointer;

      .iv-broadcast-title {
        font-size: 20px;
        color: #000000;

        span:nth-of-type(1) {
          width: 4px;
          height: 16px;
          background: #2373C8;
          border-radius: 2px;
          display: inline-block;
          margin-right: 7px;
        }
      }

      div {
        margin-top: 8px;
        font-size: 16px;
        color: #000000;
        margin-left: 5px;
      }

      p {
        font-size: 16px;
        color: #000000;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        margin-right: 30px;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
      }
    }

    .iv-broadcast-list {
      .iv-broadcast-item {
        margin-bottom: 15px;

        .iv-item-title {
          font-size: 20px;
          position: relative;
          padding-left: 10px;

          &::before {
            content: '';
            position: absolute;
            width: 4px;
            height: 16px;
            background: #2373C8;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            border-radius: 8px;
          }
        }

        .iv-item-content {
          ul {
            margin-top: 10px;

            li {
              cursor: pointer;
              font-size: 16px;
              color: rgba(0, 0, 0, 0.64);
            }
          }
        }
      }
    }
  }

  .iv-pointer {
    height: 4px;
    font-size: 30px;
    color: rgba(0, 0, 0, 0.45);
    margin-top: 6px;
    position: absolute;
    right: 30px;
    top: 0;
  }
}

.iv-broadcast::before {
  content: '';
  clear: both;
}

.iv-list-right-title {
  height: 57px;
  font-size: 16px;
  line-height: 57px;
  color: rgba(0, 0, 0, 0.85);
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 9px;

  span {
    display: inline-block;
    height: 57px;
    line-height: 57px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
    border-bottom: 2px solid #2373C8;
    font-size: 16px;
  }
}

.iv-main-width {
  //background: #fff;
}

.iv-list-guide {
  margin: 0 auto;
  width: 1200px;
  z-index: 0;
  margin-top: 24px;
  background: #FFFFFF;

  .iv-list-right {
    // float: right;
    margin-left: 296px;
    width: 904px;
    padding-right: 24px;

    &.no-menu {
      width: 1200px;
      margin-left: 0;
      padding-left: 24px;
    }
  }
}

.iv-bg-w {
  background-color: white;
  padding-bottom: 80px;
  //height: 100%;
}

/deep/ .iv-list-page {
  float: right;
  margin-top: 20px;
  padding-bottom: 28px;
}
</style>
